export default __webpack_public_path__ + "static/lozenge-dropdown-do-1-dark-ffc8cb2e63bec61f0322efc4e3703e3c1e23076718beff60c315f7ac7c4fa82b.png";